<template>
    <div class="form-content">
        <!-- 微信认证组件 -->
        <wxAuth :share="share"></wxAuth>
        <!-- title -->
        <headers :params="hraderP"></headers>
        <van-row v-if="bannerAd" class="form-item-banner">
          <van-col :span="24" v-if="bannerAd.clickRedirectUrl">
            <a :href="bannerAd.clickRedirectUrl" :title="bannerAd.title">
              <img :src="bannerAd.resourceUrl" :alt="bannerAd.title">
            </a>
          </van-col>
          <van-col :span="24" v-else>
            <img :src="bannerAd.resourceUrl" :alt="bannerAd.title">
          </van-col>
        </van-row>
        <div class="form-item-row" :class="{'error-border':errorObj.contacts}">
          <div class="ad-title">联系人<span class="must-ad">*</span></div>
          <div class="value"><input @input="errorObj.contacts = false" type="text" v-model="form.contacts" maxlength="30" placeholder="请填写联系人姓名"></div>
        </div>
        <div v-if="errorObj.contacts" class="error-box">请输入联系人</div>
        <div class="form-item-row" :class="{'error-border':errorObj.mobile}">
          <div  class="ad-title">联系方式<span class="must-ad">*</span></div>
          <div  class="value"><input @input="errorObj.mobile = false"  type="number" v-model="form.mobile" oninput="if(value.length>30)value=value.slice(0,30)" maxlength="30" placeholder="请填写联系人手机号"></div>
        </div>
        <div v-if="errorObj.mobile" class="error-box">请输入联系方式</div>
        <div class="form-item-row">
          <div class="ad-title">公司名称</div>
          <div class="value"><input type="text" v-model="form.companyName" maxlength="25" placeholder="请填写公司名称"></div>
        </div>
        <div class="form-item-row">
          <div  class="ad-title">项目名称</div>
          <div  class="value"><input type="text" v-model="form.projectName" maxlength="30" placeholder="请输入项目名称"></div>
        </div>
        <div class="form-item-row f-column" :class="{'error-border':errorObj.firstBuildingType || errorObj.secondBuildingType}">
          <div class="flex-box">
            <div class="ad-title">项目业态<span class="must-ad">*</span></div>
            <div class="value">
              <input type="text" v-model="selectedFirstType.name" placeholder="请选择一级业态" @click="showFirst = true" readonly="readonly">
              <img class="arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
              <van-popup v-model="showFirst"  position="bottom">
                <van-picker
                  show-toolbar
                  @cancel="showFirst = false"
                  :columns="firstTypeList"
                  @confirm="firstType"
                  :value-key="'name'"
                  :title="'请选择一级业态'"
                />
              </van-popup>
            </div>
          </div>
          <div style="border-top:1px solid rgba(0,0,0,.12)" class="flex-box" v-if="selectedFirstType.name">
              <div class="ad-title"></div>
              <div class="value">
                 <input type="text" v-model="selectedSecondType.name" placeholder="请选择二级业态" @click="showSecond = true" readonly="readonly">
                 <img class="arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
                 <van-popup v-model="showSecond"  position="bottom">
                  <van-picker
                      show-toolbar
                      @cancel="showSecond = false"
                      :columns="secondTypeList"
                      @confirm="secondType"
                      :value-key="'name'"
                      :title="'请选择二级业态'"
                    />
                  </van-popup>
              </div>
          </div>
        </div>
        <div v-if="errorObj.firstBuildingType"  class="error-box">请选择一级业态</div>
        <div v-if="!errorObj.firstBuildingType && errorObj.secondBuildingType"  class="error-box">请选择二级业态</div>
        <div class="form-item-row f-column" :class="{'error-border':errorObj.projectStage}">
          <div class="ad-title width-100">项目阶段<span class="must-ad">*</span></div>
          <div class="checkbox-row">
            <div class="checkbox-row-item" :class="{active : form.projectStage === '1'}" @click="radioChange('1')">
                <div>方案设计</div>
            </div>
            <div class="checkbox-row-item" :class="{active : form.projectStage === '4'}"  @click="radioChange('4')">
                <div>初步设计</div>
            </div>
            <div class="checkbox-row-item" :class="{active : form.projectStage === '2'}"  @click="radioChange('2')">
                <div>施工图</div>
            </div>
            <div class="checkbox-row-item" :class="{active : form.projectStage === '3'}"  @click="radioChange('3')">
                <div>深化设计</div>
            </div>
          </div>
        </div>
        <div v-if="errorObj.projectStage" class="error-box">请选择项目阶段</div>
        <div class="form-item-row" :class="{'f-column':selectedSystem.length,'error-border':errorObj.sysAttr}" v-if="selectedFirstType.name">
          <div class="ad-title" :class="{'width-100': selectedSystem.length}">选择系统<span class="must-ad">*</span></div>
          <div  v-if="!selectedSystem.length" class="value" :class="{'width-100': selectedSystem.length}" @click="showSystem = true">
              <input type="text" placeholder="请选择所关联的系统" @click="showSystem = true" readonly="readonly">
              <img class="arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
          </div>
          <div  @click="showSystem = true"  class="sys-flex-box" v-else>
              <p class="item-box" v-if="selectedSystem.length"><span class="system" v-for="(item,index) in selectedSystem" :key="index">{{item.name}}</span></p>
              <div class="item-limit">等{{selectedSystem.length}}个系统</div>
              <img class="check-arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
          </div>
           <dropCheckbox :params="systemList" :showMenus="showSystem" @parentData="systemType"></dropCheckbox>
        </div>
        <div v-if="selectedFirstType.name && errorObj.sysAttr" class="error-box">请选择系统</div>
        <div class="form-item-row f-column">
          <div  class="ad-title width-100">交付产品<span class="must-ad">*</span></div>
            <van-checkbox-group class="checkbox-row padding-b-16" v-model="putTypeArr" @change="errorObj.putTypeArr = false">
              <van-checkbox
                class="checkbox-row-item-more"
                v-for="item in list"
                :key="item.id"
                :name="item.id"
                checked-color="#1dbfda"
              >
                <template #icon="props">
                  <div class="check-all-item">
                    <img class="check-img-icon" :src="props.checked ? 'https://project-homedo.oss-cn-shanghai.aliyuncs.com/2bac3959-7b3b-4a94-a4cb-f9400936462b_check-act.png' : 'https://project-homedo.oss-cn-shanghai.aliyuncs.com/f6e2476b-9588-4bc0-bca9-d99538b680f6_check-no.png'" />
                    <div>{{ item.name }}</div>
                  </div>
                </template>
              </van-checkbox>
            </van-checkbox-group>
        </div>
        <div v-if="errorObj.putTypeArr" class="error-box">请选择交付产品</div>
        <div class="form-item-row">
          <div  class="ad-title">项目面积</div>
          <div  class="value"><input v-model="form.area" oninput="value=(value.replace(/[^\d]/g,'')).slice(0,9)" placeholder="请填写项目面积" maxlength="7"><span class="company-item">平方米</span></div>
        </div>
        <div class="form-item-row f-column">
          <div class="flex-box">
            <div class="ad-title">项目地址</div>
            <div class="value">
              <input type="text" v-model="areaStr" placeholder="请选择省" @click="showProvince = true" readonly="readonly">
              <img class="arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
              <van-popup v-model="showProvince"  position="bottom">
                  <van-picker
                      show-toolbar
                      @cancel="showProvince = false"
                      :columns="areaColumns"
                      @confirm="province"
                      @change="changeCity"
                      :title="'请选择项目地址'"
                    />
              </van-popup>
            </div>
          </div>
          <!-- <div style="border-top:1px solid rgba(0,0,0,.12)"  class="flex-box" v-if="selectedProvince.name">
            <div class="ad-title"></div>
            <div  class="value">
              <input type="text" v-model="selectedCity.name" maxlength="30" placeholder="请选择市" @click="showCity = true" readonly="readonly">
              <img class="arrow-btn" src="//project-homedo.oss-cn-shanghai.aliyuncs.com/f597a590-4ebd-42f2-b9ee-b774ff5201ff_ad-arrow.png" alt="">
              <van-popup v-model="showCity"  position="bottom">
                  <van-picker
                      show-toolbar
                      @cancel="showCity = false"
                      :columns="cityList"
                      @confirm="city"
                      :value-key="'name'"
                      :title="'请选择市'"
                    />
              </van-popup>
            </div>
          </div> -->
        </div>
        <div class="form-item-row f-column">
          <div class="flex-box">
            <div  class="ad-title">交稿时间</div>
            <div  class="value time-pr" v-if="!form.startTime" @click="callDateStart">请选择初稿时间</div>
            <div  class="value" v-else @click="callDateStart"><span>{{form.startTime}}</span></div>
            <span class="time-z-tips">至</span>
            <div  class="value time-pr" v-if="!form.endTime" @click="callDateEnd">请选择最终时间</div>
            <div  class="value" v-else @click="callDateEnd"><span>{{form.endTime}}</span></div>
          </div>
        </div>
        <div class="form-item-row">
          <div  class="ad-title">设计预算</div>
          <div  class="value"><input v-model="form.budget" placeholder="请填写金额数值"  oninput="value=(value.replace(/[^\d]/g,'')).slice(0,9)" maxlength="10"><span class="company-item">元</span></div>
        </div>
        <div class="form-item-row f-column">
          <div  class="ad-title width-100">额外要求</div>
          <textarea  v-model="form.description" maxlength="200" placeholder="请填写额外的要求"></textarea>
          <div  class="textarea-length"><span style="color:rgba(0,0,0,.85)">{{form.description.length}}</span>/200</div>
        </div>
        <!-- <div class="bottom-style"></div> -->
        <div class="form-item-button">
          <div ><button @click="submitDemand">提交需求</button></div>
        </div>
      <dateTimePlug v-show="dateStart.show" :params="dateStart" @confirm="confirmStart" @cancel="cancelStart"></dateTimePlug>
      <dateTimePlug v-show="dateEnd.show" :params="dateEnd" @confirm="confirmEnd" @cancel="cancelEnd"></dateTimePlug>
      <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
    </div>
</template>

<script>
import axios from 'axios'
import dropRadio from '@/components/dropRadio'
import dropCheckbox from '@/components/dropCheckbox'

import headers from '@/components/headers'
import dateTimePlug from '@/components/datetime'
import { dateFormat } from '@/filters/commonFilters'
// import { toLogin } from '@/utils/common'
import wxAuth from '@/components/wxAuth'
import {getAdvertising} from '@/api/common'
import {queryFirstType, querySecondType, querySystemType, queryProvince} from '@/api/demands/demand'
import { Row, Col, Checkbox, CheckboxGroup, RadioGroup, Radio, Toast, Notify, Popup , Picker } from 'vant'
import { mapState } from 'vuex'
import { toLogin, isLogin } from '@/utils/common'
export default {
  name: 'add-demand-form',
  components: { Row, Col, Checkbox, CheckboxGroup, RadioGroup, dateTimePlug, Radio, Toast, Notify, wxAuth, headers, dropRadio, dropCheckbox },
  computed: {
    ...mapState({
      API2DomainUrl: state => state.baseData.API2DomainUrl,
      token: state => state.user.ticket,
      userId: state => state.user.AccountId,
      userName: state => state.user.AccountName
    })
  },
  data () {
    return {
      showPicker: true,
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '提交需求',
        lefticon: true
      },
      bannerAd: null,
      radio: '',
      list: [{id: 4, name: '标书'}, {id: 1, name: '方案'}, {id: 3, name: '图纸'}, {id: 2, name: '报价清单'}],
      result: [],
      dateStart: {
        confirm: 'confirm',
        cancel: 'cancel',
        show: false,
        title: '请选择时间'
      },
      dateEnd: {
        confirm: 'confirm',
        cancel: 'cancel',
        show: false,
        title: '请选择时间'
      },
      form: {
        contacts: '', // 联系人
        mobile: '', // 手机号
        companyName: '', // 公司名称
        description: '', // 需求描述
        projectName: '', // 项目名称
        projectStage: '', //  项目阶段 1.规范设计，2投标设计 3深化设计 0其他
        putType: '', // 期望交付成果  1项目方案，2 配置清单，3设计图纸 -->逗号分割
        // expectTime: dateFormat(new Date(), 'yyyy-MM-dd'),
        budget: '', // 预算
        firstBuildingType: '', // 一级业态
        secondBuildingType: '', // 二级业态
        sysAttr: '', // 系统
        startTime: '', // 初稿时间
        endTime: '', // 终稿时间
        area: '', // 项目面积
        provinceId: '',
        cityId: ''
      },
      errorObj: {
        contacts: false,
        mobile: false,
        firstBuildingType: false,
        secondBuildingType: false,
        projectStage: false,
        sysAttr: false,
        putTypeArr: false
      },
      putTypeArr: [],
      firstTypeList: [],
      secondTypeList: [],
      systemList: [],
      provinceList: [],
      cityList: [],
      showFirst: false,
      showSecond: false,
      showSystem: false,
      showProvince: false,
      showCity: false,
      selectedFirstType: {},
      selectedSecondType: {},
      selectedSystem: [],
      selectedProvince: {},
      selectedCity: {},
      areaColumns: [],
      areaStr: '',
      upKey: true
    }
  },
  created () {
    if (!isLogin()) {
      toLogin()
    }
    this.$store.dispatch('USER_GET_INFO')
    if (this.getterCache('DEMAND_FORM_CACHE')) {
      this.form = JSON.parse(this.getterCache('DEMAND_FORM_CACHE'))
      this.clearCache('DEMAND_FORM_CACHE')
    }
    this.fetchDemandAd()
    this.getFirstType()
    this.getSystemType()
    this.getProvince()
  },
  methods: {
    changeCity (picker, values, index) {
      const checckObj = values[index]
      if (index === 0) {
        this.getCity(checckObj.value)
      }
    },
    province (picker) {
      console.log(picker)
      this.showProvince = false
      this.form.provinceId = picker[0].value
      this.form.cityId = picker[1].value
      this.areaStr = `${picker[0].text} ${picker[1].text}`
      // console.log(data, index)
      // this.showProvince = false
      // this.form.provinceId = data.id
      // this.selectedProvince = data
      // this.selectedCity = []
      // this.form.cityId = ''
    },
    // city (data) {
    //   this.showCity = false
    //   this.form.cityId = data.id
    //   this.selectedCity = data
    // },
    firstType (data) {
      this.errorObj.firstBuildingType = false
      this.showFirst = false
      this.form.firstBuildingType = data.id
      this.selectedFirstType = data
      this.selectedSecondType = []
      this.selectedSystem = []
      this.form.secondBuildingType = ''
      this.form.sysAttr = ''
      this.getSecondType()
      this.getSystemType()
    },
    secondType (data) {
      this.errorObj.secondBuildingType = false
      this.showSecond = false
      this.form.secondBuildingType = data.id
      this.selectedSecondType = data
    },
    systemType (data) {
      this.errorObj.sysAttr = false
      this.showSystem = false
      this.selectedSystem = data
      var systemArr = data.map(item => {
        return item.id
      })
      this.form.sysAttr = systemArr.join(',')
    },
    // 获取省
    getProvince () {
      let _this = this
      queryProvince(0)
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            _this.provinceList = result.data.data.areas
            const provinceData = {
              defaultIndex: 0,
              values: _this.provinceList.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.areaColumns, 0, provinceData)
            // eslint-disable-next-line no-useless-return
            if (!provinceData.values.length) return
            this.getCity(provinceData.values[0].value)
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取市
    getCity (id) {
      let _this = this
      console.log(id)
      queryProvince(id)
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            _this.cityList = result.data.data.areas
            const cityData = {
              defaultIndex: 0,
              values: _this.cityList.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.areaColumns, 1, cityData)
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取一级业态列表
    getFirstType () {
      queryFirstType()
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            this.firstTypeList = result.data.data.requireTypeSysDataList
            console.log(this.firstTypeList)
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取二级业态列表
    getSecondType () {
      let params = {
        parentId: this.form.firstBuildingType
      }
      querySecondType(params)
        .then(result => {
          console.log(result)
          if (result.status === 200 && result.data && result.data.data) {
            this.secondTypeList = result.data.data.requireTypeSysDataList
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取系统列表
    getSystemType () {
      let params = {
        typeId: this.form.firstBuildingType
      }
      querySystemType(params)
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            this.systemList = result.data.data.requireTypeSysDataList
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    radioChange (item) {
      this.errorObj.projectStage = false
      this.form.projectStage = item
    },
    confirmStart (event) {
      this.form.startTime = dateFormat(event, 'yyyy年MM月dd')
      this.dateStart.show = false
    },
    cancelStart () {
      this.dateStart.show = false
    },
    confirmEnd (event) {
      this.form.endTime = dateFormat(event, 'yyyy年MM月dd')
      this.dateEnd.show = false
      console.log(!(this.form.endTime < this.form.startTime))
      if (this.form.endTime < this.form.startTime) {
        Toast('初稿时间不能大于最终时间')
        this.form.endTime = ''
        return false
      }
    },
    cancelEnd () {
      this.dateEnd.show = false
    },
    // 调用日期插件
    callDateStart () {
      this.dateStart.show = true
    },
    // 调用日期插件
    callDateEnd () {
      this.dateEnd.show = true
    },
    // 获取广告
    fetchDemandAd () {
      getAdvertising('M_DEMAND_SUBMIT_TOP_1')
        .then(result => {
          if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
            this.bannerAd = result.data.data[0]
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    submitDemand () {
      if (!this.upKey) return
      this.form.userId = this.userId
      this.form.userName = this.userName
      this.form.source = 4
      this.form.putType = this.putTypeArr && this.putTypeArr.join(',')
      if (this.$route.query.source === 'srv') {
        this.form.source = 6
      }
      let flag = true
      if (!this.form.contacts || this.form.contacts === '') {
        this.errorObj.contacts = true
        flag = false
      }
      if (!this.form.mobile || this.form.mobile === '') {
        this.errorObj.mobile = true
        flag = false
      }
      if (this.form.mobile && this.form.mobile.length > 30) {
        Toast('联系方式不能超过30位')
        flag = false
      }
      if (!this.form.firstBuildingType || this.form.firstBuildingType === '') {
        this.errorObj.firstBuildingType = true
        flag = false
      } else {
        if (!this.form.secondBuildingType || this.form.secondBuildingType === '') {
          this.errorObj.secondBuildingType = true
          flag = false
        }
        if (!this.form.sysAttr || this.form.sysAttr === '') {
          this.errorObj.sysAttr = true
          flag = false
        }
      }
      if (!this.form.projectStage || this.form.projectStage === '') {
        this.errorObj.projectStage = true
        flag = false
      }

      if (this.putTypeArr.length <= 0) {
        this.errorObj.putTypeArr = true
        flag = false
      }

      if (!flag) return
      if (this.form.area && this.form.area.length > 7) {
        Toast('项目面积不能超过7位')
        flag = false
      }
      if (this.form.budget && this.form.budget.length > 10) {
        Toast('设计预算不能超过10位')
        flag = false
      }
      if (!flag) return
      this.upKey = false
      this.$store.dispatch('DEMAND_ADD_CUSTOMIZED', {...this.form, versionnub: this.$route.query.versionnub ? this.$route.query.versionnub : 1}).then(result => {
        if (result.status === 200 && result.data && result.data.code === 200) {
          this.getKeTuo()
          Toast('需求提交成功')
          setTimeout(() => {
            this.upKey = true
            this.$router.replace('/demand/success.html')
          }, 2000)
        } else {
          this.upKey = true
          Notify('提交失败')
        }
      })
    },
    async getKeTuo () {
      var ticket = $HMD$.Cookie('ticket')
      const URL = 'https://common-api.' + $HMD$.rApi.S + 'homedo.com'
      // 其他活动请求path
      const NORMAL_PATH = `/bff-common-api/solicitationFor/sendEmail?type=4`
      const result = await axios({
        method: 'get',
        url: URL + NORMAL_PATH,
        headers: {
          ticket: ticket
        }
      })
      if (result.respCode === '0000') {
        console.log(result.respDesc);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form-content{
  background: #FFF;
  padding-bottom: 20px;
  .form-item-row {
    display: flex;
    align-items: center;
    width: 344px;
    margin: 0 auto;
    color: rgba(0,0,0,0.65);
    border-bottom: 1px solid rgba(0,0,0,0.12);
    &.error-border {
      border-bottom: 1px solid #FF3030;
    }
    &.f-column {
      flex-direction: column;
    }
    .time-z-tips {
      margin-right: 14px;
    }
    .time-pr {
      color:  rgba(0,0,0,0.25);
    }
    .check-arrow-btn {
       width: 24px;
      height: 24px;
      position: absolute;
      bottom: 16px;
      right: 4px;
      font-size: 20px;
      pointer-events: none;
    }
    .item-limit{
        display: inline-block;
        width: 28%;
        height: 100%;
        color: #409EFF;
        font-size: 14px;
     }
     .sys-flex-box {
       display: flex;
       width: 100%;
       position: relative;
       align-items: center;
       padding-bottom: 16px;
     }
    .item-box{
      width: 72%;
      height: 24px;
      background-color: #ffffff;
      overflow: hidden;
      .system{
        display: inline-block;
        color: #2F7BFF;
        border: 1px solid #2F7BFF;
        background: rgba(47,123,255,0.1);
        border-radius: 4px;
        padding: 0 4px;
        height: 24px;
        line-height: 22px;
        margin: 0 8px 12px 0;
        box-sizing: border-box;
      }

    }
  }
  .flex-box {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .width-100 {
    width: 100%!important;
  }
  .form-item{
    &-banner{
      img{
        vertical-align: middle;
        width: 100%;
      }
     }
    &-row{
      .ad-title{
        background-color: #FFF;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        color: #000000;
        width: 85px;
        white-space:nowrap;
        display: flex;
        align-items: center;
        line-height: 1;
        .must-ad {
          color: #2F7BFF;
          padding-top: 4px;
          display: block;
          margin-left: 4px;
          font-size: 16px;
        }
      }
      .value{
        flex: 1;
        height: 50px;
        line-height: 50px;
        position: relative;
        input{
          width: 100%;
          font-size: 14px;
          border: none;
        }
      }
      textarea{
        width: 100%;
        height: 73px;
        font-size: 16px;
        border: none;
        resize:none;
        vertical-align: middle;
      }
      .textarea-length{
        font-size: 13px;
        text-align: right;
        width: 100%;
        line-height: 1;
        padding: 16px 0;
        color: rgba(0,0,0,.25);
      }
      .checkbox-row{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        color: rgba(0,0,0,0.45);
        font-size: 13px;
        &-item{
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          width: 80px;
          height: 24px;
          line-height: 22px;
          box-sizing: border-box;
          margin-right: 8px;
          margin-bottom: 16px;
          border: 1px solid rgba(0,0,0,0.25);
          border-radius: 5px;
          &.active {
            border: 1px solid #2f7bff;
            color:#2F7BFF;
            background: rgba(47,123,255,0.10);
          }
           &:last-child{
             margin-right: 0;
            }
         }
        .check-all-item {
          height: 24px;
          padding-bottom: 16px;
          margin-right: 20px;
          font-size: 15px;
          color: rgba(0,0,0,0.85);
          display: flex;
          align-items: center;
          div {
            margin-left: 8px;
          }
          &:nth-of-type(4n) {
            margin-right: 0;
          }
        }
      }
      .checkbox-row-item-more:last-child .check-all-item {
          margin-right: 0;
      }
     }
    &-button {
       width: 344px;
       margin: 16px auto 0;
      button {
        width: 100%;
        border: none;
        height: 44px;
        background-color: #2f7bff;
        border-radius: 4px;
        font-size: 18px;
        color: #FFF;
      }
    }
  }
}
  // .bottom-style {
  //   height: 50px;
  //   width: 100%;
  // }
  .line-item{
    height: 1px;
    width: 100%;
    background-color: #e5e5e5;
    border: 0;
  }
  .company-item{
    position: absolute;
    right: 10px;
  }
  .arrow-span{
    position: relative;
  }
  .arrow-btn{
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 12px;
    right: 4px;
    font-size: 20px;
    pointer-events: none;
  }
  .input-second{
    padding-left: 0;
    padding-right: 0;

  }
  .padding-b-16 {
    padding-bottom: 16px;
  }

   ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:  rgba(0,0,0,.25)
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:  rgba(0,0,0,.25)

  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:  rgba(0,0,0,.25)

  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:  rgba(0,0,0,.25)
  }
  .check-img-icon {
    width:20px;
    height:20px
  }
  .error-box {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #FF3030;
    width: 343px;
    margin: 0 auto;
  }
</style>
<style lang="scss">
.form-content {
  .van-picker__toolbar {
    background: #f9fafc!important;
    .van-picker__confirm {
      color: #2f7bff;
      font-size: 15px;
    }
  }
  .van-ellipsis.van-picker__title {
    font-size: 15px;
    color: rgba(0,0,0,.65);
  }
  .van-picker__cancel, .van-picker__confirm {
    line-height: 1;
  }
  .to-index{
    width: 122px;
    position: fixed;
    right: 10px;
    bottom: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/demand/form.vue